export default __webpack_public_path__ + "static/media/game-over-img.7cace5af.png";